import { render, staticRenderFns } from "./SwitchIdDialog.vue?vue&type=template&id=5741e06c&scoped=true"
import script from "./SwitchIdDialog.vue?vue&type=script&lang=js"
export * from "./SwitchIdDialog.vue?vue&type=script&lang=js"
import style0 from "./SwitchIdDialog.vue?vue&type=style&index=0&id=5741e06c&prod&lang=stylus"
import style1 from "./SwitchIdDialog.vue?vue&type=style&index=1&id=5741e06c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5741e06c",
  null
  
)

export default component.exports